module.exports = __webpack_public_path__ + "static/media/chart_white.9ae8f141.png";